/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, rightChain: NonNullable<unknown>, metric: NonNullable<unknown> }} Chain_Page_Compare_Dev_Activity_SameInputs */



/**
* | output |
* | --- |
* | "{leftChain} and {rightChain} have the same amount of {metric}" |
*
* @param {Chain_Page_Compare_Dev_Activity_SameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_dev_activity_same = /** @type {((inputs: Chain_Page_Compare_Dev_Activity_SameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Dev_Activity_SameInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} and ${i?.rightChain} have the same amount of ${i?.metric}`)
});